import axios from 'axios'
import qs from 'qs'
import store from '../store'
import {
  Message
} from 'element-ui'
import {
  VueAxios
} from './axios'
import router from '../router/index'

// const baseURL = 'http://139.224.52.214:9888/';
const baseURL = 'http://47.103.193.131/huiyiApi'
// const baseURL = 'http://localhost:9077/'
// const baseURL = 'http://127.0.0.1:9888/';
// const baseURL = 'http://localhost:9888/'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: 'http://192.168.3.15:10010/',
  // baseURL: 'https://qsb.backend.shenzaojiaoyu.com/',
  //baseURL: 'http://125.77.165.192:10010/',
  // 测试ip地址
  // baseURL: 'http://localhost:9888/',
  // baseURL: 'http://localhost:12012/',
  baseURL: baseURL,


  timeout: 100000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token

    if (error.response.status === 403) {
      Message.error(data.message)
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      Message.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      router.replace({
        path: '/login'
      })
    }
  }
  return Promise.reject(error)
}

// 请求拦截器
request.interceptors.request.use(config => {
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/json'
  } else if (config.method === 'get') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    if (config.data) {
      config.url = config.url + '?' + qs.stringify(config.data)
    }
  }
  config.headers['token'] = localStorage.getItem('apiToken')
  console.log('configconfigconfigconfig', config)
  return config
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response) => {
  if (response && response.data && response.data.code && response.data.code) {

    if (response.data.code == '-1002') {
      router.replace({
        path: '/pages/login'
      })
      errorHandler()
    }

    if (response.data && response.data.code != 200 && response.data.code != 0) {

      Message.error(response.data.msg ? response.data.msg : '服务器升级中，请稍后再试。')
      errorHandler()
    } else {
      if (response.data.code == 200) {
        return response.data
      } else {
        Message.error(response.data.msg)
        errorHandler()
      }
    }
  }
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default {
  request, baseURL,
  post(url, data, headers) {
    return new Promise((resolve, reject) => {
      request({
        method: 'post',
        url,
        data: data,
        headers: headers
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  get(url, data) {
    return new Promise((resolve, reject) => {
      request({
        method: 'get',
        url,
        params: data
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js